<template>
	<SMSListContainer area="superadmin" />
</template>

<script>
	import SMSListContainer from '@/views/admin/SMSListContainer'

	export default {
		name: 'SmsManagementView',
		components: {
			SMSListContainer
		},
		data() {
			return {

			}
		},
	}
</script>